<template>
    <div>
        <v-col cols="12">
            <v-alert
                v-if="informAlert == true"
                close-text="Close Alert"
                dense
                text
                type="success"
                dismissible
                style="text-align: left"
            >
                {{ informText }}
            </v-alert>

            <v-alert
                v-if="informAlert == false"
                close-text="Close Alert"
                dense
                text
                type="error"
                dismissible
                dark
                style="text-align: left"
            >
                {{ informText }}
            </v-alert>
        </v-col>

        <v-col cols="12">
            <v-row>
                <v-col cols="6" style="text-align: left;">
                    <table width="100%" style="border: none !important;">
                        <tr>
                            <td style="text-align: left;width: 30%;">Created At:</td>
                            <td style="text-align: left;width: 70%;">{{ warehouseExportData.created_at }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Created By:</td>
                            <td style="text-align: left;">{{ warehouseExportData.created_by }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Warehouse:</td>
                            <td style="text-align: left;">{{ warehouseExportData.warehouse_code }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Receiver:</td>
                            <td style="text-align: left;">{{ warehouseExportData.receiver }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Total Quantity:</td>
                            <td style="text-align: left;">{{ warehouseExportData.total_quantity }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Note:</td>
                            <td style="text-align: left;">{{ warehouseExportData.note }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Delivered In Full By:</td>
                            <td style="text-align: left;">
                                <template v-if="!warehouseExportData.delivered_in_full_by">
                                    <v-btn 
                                        v-if="warehouseExportData.status != 'Canceled' && roles.update_export_doc" 
                                        color="info" style="margin-bottom:5px" 
                                        @click="saveData('delivered_in_full_by')">Delivered In Full</v-btn>
                                </template>
                                <template v-else>
                                    {{ warehouseExportData.delivered_in_full_by }}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Received In Full By:</td>
                            <td style="text-align: left;">
                                <template v-if="!warehouseExportData.received_in_full_by">
                                    <v-btn 
                                        v-if="warehouseExportData.status != 'Canceled' && roles.update_export_doc"
                                        color="info" 
                                        @click="saveData('received_in_full_by')">Received In Full</v-btn>
                                </template>
                                <template v-else>
                                    {{ warehouseExportData.received_in_full_by }}
                                </template>
                            </td>
                        </tr>
                        <tr v-if="warehouseExportData.status == 'Canceled'">
                            <td><b style="color: red;">Canceled</b></td>
                        </tr>
                    </table>
                </v-col>
                <v-col cols="6">
                        <table width="100%" class="batchInfo">
                            <tr>
                                <td class="batchInfoTd" style="text-align: left;">Batch No.</td>
                                <td class="batchInfoTd" style="text-align: left;">Quantity</td>
                            </tr>

                            <tr v-for="(i,indexi) in warehouseExportData.batches" :key="indexi">
                                <td class="batchInfoTd" style="text-align: left;">{{ i.batch_number }}</td>
                                <td class="batchInfoTd" style="text-align: left;">{{ i.quantity }}</td>
                            </tr>
                        </table>
                </v-col>
                <v-col cols="12">
                    <v-btn color="red" 
                        @click="cancelData('cancel')" 
                        v-if="warehouseExportData.status != 'Canceled' && roles.update_export_doc"
                        style="color:white;float:left">
                        Cancel
                    </v-btn>
                    <v-btn color="orange" 
                        @click="closeDialog" 
                        style="color:white;float:right">
                        Close
                    </v-btn>
                    <v-btn color="purple" 
                        @click="exportItem" 
                        v-if="warehouseExportData.status != 'Canceled' && !loading && roles.export_export_doc"
                        style="color:white;float:right;margin-right:5px;"
                        >
                        CSV File
                    </v-btn>
                    <v-btn color="purple" 
                        v-if="warehouseExportData.status != 'Canceled' && loading"
                        style="color:white;float:right;margin-right:5px;" disabled>
                        PROCESSING...
                    </v-btn>
                </v-col>
            </v-row>
            
        </v-col>
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment-timezone";
    import Amplify, { Auth } from "aws-amplify";
    

    Amplify.configure({
    Auth: {
        region: "ap-southeast-1",
        userPoolId: "ap-southeast-1_8vBdk5PAd",
        userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
        mandatorySignIn: true,
    },
    });

    export default {
        name:"DialogWarehouseExport",
        props:{
            selectedItem: Object,
            roles: Object,
        },  
        data: () => ({
            warehouseExportData: {},
            informText: '',
            informAlert: null,
            userId:'',
            loading: false,
        }),
        methods:{
            async loadData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "warehouseExportEdit-loadData"
                );
                

                if (currentSession.accessToken) {
                    await axios
                    .get(window.domain + "warehouse-export/" + this.selectedItem._id, {
                        headers: { Authorization: currentSession.accessToken },
                    })
                    .then((response) => {
                        console.log('response: ',response)
                        this.warehouseExportData = response.data.data;
                        console.log('this.warehouseExportData: ',this.warehouseExportData)
                        this.warehouseExportData.confirmed_at = moment(this.warehouseExportData.confirmed_at).format("DD/MMM/YYYY - HH:mm:ss");
                        this.warehouseExportData.created_at = moment(this.warehouseExportData.created_at).format("DD/MMM/YYYY - HH:mm:ss");
                        this.warehouseExportData.updated_at = moment(this.warehouseExportData.updated_at).format("DD/MMM/YYYY - HH:mm:ss");
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        this.warehouseExportData = {};
                    });
                } else {
                    console.log("undefined warehouseExportEdit-loadData-undefined: ",currentSession);
                }
            }, 

            async saveData(type){
                console.log('type: ',type)

                var currentSession = await this.$root.$refs.App.currentSession(
                    "vendor-edit-saveData"
                );
                //console.log('currentSession: ',currentSession.accessToken)
                if (currentSession.accessToken) {
                    let data = {}

                    if(type == 'received_in_full_by'){
                        data['received_in_full_by'] = this.userId
                    }else if(type == 'delivered_in_full_by'){
                        data['delivered_in_full_by'] = this.userId
                    }else if(type == 'cancel'){
                        data['cancel'] = true
                    }

                    console.log('data: ',data)

                    await fetch(window.domain + "warehouse-export/" + this.selectedItem._id, {
                        method: "PUT",
                        headers: { Authorization: currentSession.accessToken },
                        body: JSON.stringify(data),
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("data: ", data);
                            if(data.error_message != ''){
                                this.informAlert = false
                                this.informText = data.error_message
                            }

                            this.loadData()
                        })
                        .catch((error) => console.log("Error: ", error));
                } else {
                    console.log(
                    "currentSession vendor-edit-saveData-undefined: ",
                    currentSession
                    );
                }
            },

            async cancelData(){
                let i = confirm("Are you sure to delete this item?")
                if(i){
                    await this.saveData("cancel")
                }
            },

            async exportItem(){
                this.loading = true
                var currentSession = await this.$root.$refs.App.currentSession(
                    "warehouseExport-exportCSV"
                    );
                    if (currentSession.accessToken) {
                        await fetch(window.domain + "warehouse-export/export/" + this.selectedItem._id, {
                            method: "POST",
                            headers: { Authorization: currentSession.accessToken },
                        })
                        .then((response) => response.json())
                        .then(data => {
                            console.log('data: ',data)
                            if(data.error_message != ''){
                                this.informText = data.error_message
                                this.informAlert = false
                            }else{
                                this.informText = "We're currently preprocessing your order data. System will send a file to your email when completed."
                                this.informAlert = true
                            }
                            this.loading = false
                        })
                        .catch((error) => {
                        console.log("Error:", error);
                        });
                    } else {
                    console.log("currentSession warehouseExport-exportCSV-undefined: ", currentSession);
                    }
            },

            closeDialog(){
                this.$root.$refs.warehouseExport.turnOffDialog();
            }
        },

        async mounted(){
            try {
                await Auth.currentAuthenticatedUser({ bypassCache: false });

                var currentSession;
                try {
                    currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
                    console.log("warehouseExportEdit currentSession: ", currentSession);
                } catch (error) {
                    console.log("warehouseExportEdit error: ", error);
                }

                if (currentSession != undefined) {
                    let username = currentSession.accessToken.payload.username;
                    this.userId = username;
                }   
            } catch (error) {
                console.log("User logged out!");
                this.$router.push("/login");
            }

            await this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
.batchInfo, .batchInfoTh, .batchInfoTd {
  border: 1px solid;
  padding:2px;
}

.batchInfo {
  border-collapse: collapse;
}
</style>